import { render, staticRenderFns } from "./PropertyCreateDialog.vue?vue&type=template&id=70aa9b6f&scoped=true"
import script from "./PropertyCreateDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aa9b6f",
  null
  
)

export default component.exports